import React from "react";
import { Play } from "lucide-react";
import { SectionTitle } from "./primitives";

/**
 * Featured Videos grid. Shown on screen and in browser print, but excluded
 * from the Download-PDF (which appends its own clickable-thumbnail page).
 */
const VideosSection = ({ videos, onPlayVideo }) => (
  <section className="pdf-exclude">
    <SectionTitle icon={Play}>Featured Videos</SectionTitle>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {videos.map((v) => (
        <button
          key={v.id}
          onClick={() => onPlayVideo(v.id)}
          className="group relative block w-full overflow-hidden rounded-lg ring-1 ring-black/10 shadow-sm focus:outline-none focus:ring-2 focus:ring-[var(--ink)]"
          aria-label={`Play ${v.title}`}
        >
          <div className="aspect-video w-full bg-[var(--track)]">
            <img
              src={v.thumb}
              alt={v.title}
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          </div>
          <span className="absolute inset-0 flex items-center justify-center bg-black/25 transition-colors group-hover:bg-black/35">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/90 shadow-md transition-transform group-hover:scale-110">
              <Play size={16} className="ml-0.5 text-[var(--ink)] fill-[var(--ink)]" />
            </span>
          </span>
        </button>
      ))}
    </div>
  </section>
);

export default VideosSection;
